import { useMemo } from "react";
import { Link } from "react-router-dom";
import ReactImageMagnify from "react-image-magnify";
import { FlagRegionByIso } from "components/Function";

const useColumnTableProductNew = (heightRow = 100) => {
    const columns = useMemo(() => {
        return [
            {
                field: "_id",
                headerName: "",
                sortable: false,
                editable: false,
                cellClass: "centered-cell",
                width: 10,
                cellRenderer: ({ rowIndex, value: cell, data: row }) => rowIndex + 1,
            },
            {
                field: "product_name",
                headerName: "Product",
                sortable: false,
                editable: false,
                cellClass: "overflow-visible",
                width: 500,
                cellRenderer: ({ data: row, cell }) => (
                    <div className="d-flex align-items-center p-4" style={{ height: heightRow - 1 + "px" }}>
                        <ReactImageMagnify
                            {...{
                                smallImage: { alt: "", width: 60, height: 60, src: row.cover_url },
                                largeImage: { src: row.cover_url, width: 600, height: 600 },
                                enlargedImageContainerDimensions: { width: "600%", height: "600%" },
                                enlargedImageContainerStyle: { zIndex: 99 },
                                imageClassName: "overflow-hidden",
                            }}
                        />
                        <div
                            className="d-flex flex-column lh-lg gap-2 ms-4"
                            style={{
                                overflow: "hidden",
                                flex: "1",
                            }}
                        >
                            <span
                                data-tooltip-id="my-tooltip"
                                data-tooltip-content={row.product_name}
                                className="mb-0"
                                style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    flex: "1",
                                }}
                            >
                                <Link
                                    role="button"
                                    target="_blank"
                                    to={`/admin/spy-advanced/products/${row.product_id}`}
                                >
                                    {row.product_name}
                                </Link>
                            </span>
                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                <span
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-content={"Price"}
                                    className="fs-6 text-danger mb-0"
                                >
                                    {row.real_price}
                                </span>
                                {row.commission && (
                                    <span
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content={"Commission"}
                                        className="badge bg-warning text-white rounded-pill"
                                    >
                                        {row.commission}
                                    </span>
                                )}
                            </div>
                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                {row.region?.key ? (
                                    <FlagRegionByIso name={row.region.name} iso={row.region.key} />
                                ) : (
                                    ""
                                )}
                                <span className="badge bg-info text-white rounded-pill">{row.category}</span>
                                <span
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-content={"Product Experience Points"}
                                    className="badge bg-info text-white"
                                >
                                    {row.product_rating}
                                </span>
                                <span
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-content={"Comments"}
                                    className="badge bg-info text-white"
                                >
                                    {row.review_count}
                                </span>
                                {Boolean(row.is_free_shipping) && (
                                    <i
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content={"Free Shipping"}
                                        className="fas fa-shipping-fast fs-3"
                                    ></i>
                                )}
                            </div>
                        </div>
                    </div>
                ),
            },

            {
                field: "seller",
                headerName: "Shop",
                sortable: false,
                editable: false,
                cellRenderer: ({ data }) => {
                    const row = data.seller;
                    return (
                        row && (
                            <div className="d-flex align-items-center p-4" style={{ height: heightRow - 1 + "px" }}>
                                <img
                                    src={row?.cover_url}
                                    alt={row.seller_name}
                                    className="me-3"
                                    style={{ width: 60, height: 60, objectFit: "cover", borderRadius: "100%" }}
                                />
                                <div className="lh-base">
                                    <span
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content={row.seller_name}
                                        className="mb-0"
                                        style={{
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            flex: "1",
                                        }}
                                    >
                                        <Link
                                            role="button"
                                            target="_blank"
                                            to={`/admin/spy-advanced/products/${row.seller_id}`}
                                        >
                                            {row.seller_name}
                                        </Link>
                                    </span>
                                    <p>Sales: {row.total_sale_cnt}</p>
                                </div>
                            </div>
                        )
                    );
                },
            },
            {
                field: "avg_price",
                headerName: "Price",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "influencers_count",
                headerName: "Influencers",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "total_sale_gmv_7d_amt",
                headerName: "GMV Last 1 day",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "total_sale_gmv_amt",
                headerName: "GMV",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "total_sale_7d_cnt",
                headerName: "Sales Last 1 day",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "total_sale_cnt",
                headerName: "Cumulative Sales",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "commission",
                headerName: "Commission",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "-",
                headerName: "Actions",
                editable: false,
                cellClass: "centered-cell",
                width: 140,
                // pinned: "right",
                cellRenderer: ({ data: row }) => (
                    <>
                        <Link
                            role="button"
                            to={`/admin/spy-advanced/products/${row.product_id}`}
                            className="btn btn-icon btn-bg-light btn-active-color-warning btn-sm me-2"
                            data-tooltip-id="my-tooltip"
                        >
                            <i className="fa fa-search fs-2"></i>
                        </Link>
                    </>
                ),
            },
        ];
    }, [heightRow]);

    return columns;
};

export default useColumnTableProductNew;
